export var NSBNUserAPIResponses;
(function (NSBNUserAPIResponses) {
    var CognitoBNGroups;
    (function (CognitoBNGroups) {
        CognitoBNGroups["Seed"] = "_SeedToLocal";
        CognitoBNGroups["User"] = "BNRole_User";
        CognitoBNGroups["Admin"] = "BNRole_Admin";
    })(CognitoBNGroups = NSBNUserAPIResponses.CognitoBNGroups || (NSBNUserAPIResponses.CognitoBNGroups = {}));
})(NSBNUserAPIResponses || (NSBNUserAPIResponses = {}));
//# sourceMappingURL=apiResponses.js.map